export default __webpack_public_path__ + "static/favicon-4f251723ca44f22fe1f4a59053e3406a.ico";